const getters = {
    collapseMenu: state => state.user.collapseMenu,
    userInfo: state => state.user.userInfo,
    isLogin: state => state.user.isLogin,
    dictionary: state => state.user.dictionary,
    chooseHospital: state => state.user.chooseHospital
}
export default getters
